import { title } from "assets/jss/material-kit-react.jsx";

const thumbnailsStyle = {
  section: {
    padding: "30px 0",
    textAlign: "center",
    color: "black"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: "#999"
  },
  noVideoAvailable: {
    fontSize: "2em"
  },
  thumbnail: {
    border: "1px solid silver",
    borderRadius: "5px",
    padding: "10px 0",
    margin: "5px 0px"
  }
};

export default thumbnailsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/homePageSections/thumbnails.jsx